(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mancomm-industries"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupIndustries(root) {
    var row = root.querySelector('[data-mnc-row]');
    var prevBtn = root.querySelector('[data-mnc-prev]');
    var nextBtn = root.querySelector('[data-mnc-next]');
    if (!row) return;

    var cards = Array.prototype.slice.call(row.querySelectorAll('.mnc-indcard'));
    var dragging = false;
    var dragFrom = null;
    var dragMoved = false;

    row.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Cards are <a> tags, which browsers natively let you "drag" (e.g. to
    // bookmark/open in a new tab). That native gesture competes with our
    // own pointer-based drag-to-scroll below, so it's disabled outright -
    // independent of when we capture the pointer for our own logic.
    row.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function cardStep() {
      if (!cards[0]) return 0;
      var gap = parseFloat(getComputedStyle(row).gap) || 16;
      return cards[0].offsetWidth + gap;
    }
    function maxScroll() {
      return Math.max(0, row.scrollWidth - row.clientWidth);
    }
    // How many cards are fully visible at once - recalculated live, since it
    // changes with viewport width (1 on mobile, several on desktop).
    function cardsPerPage() {
      var s = cardStep();
      if (!s) return 1;
      return Math.max(1, Math.floor(row.clientWidth / s));
    }
    function nearestIndex() {
      var s = cardStep();
      if (!s) return 0;
      return Math.max(0, Math.min(cards.length - 1, Math.round(row.scrollLeft / s)));
    }
    function render() {
      // If every card already fits with nothing to scroll to, the arrows
      // have nothing to do - hide them instead of showing them disabled.
      var noScrollNeeded = maxScroll() <= 0;
      if (prevBtn) {
        prevBtn.hidden = noScrollNeeded;
        prevBtn.disabled = noScrollNeeded || row.scrollLeft <= 2;
      }
      if (nextBtn) {
        nextBtn.hidden = noScrollNeeded;
        nextBtn.disabled = noScrollNeeded || row.scrollLeft >= maxScroll() - 2;
      }
    }
    // Arrow clicks move a full page (however many cards currently fit),
    // not one card at a time - avoids the "barely moves" feel near the end.
    function scrollByPage(direction) {
      var amount = cardsPerPage() * cardStep() * direction;
      var target = Math.max(0, Math.min(maxScroll(), row.scrollLeft + amount));
      row.scrollTo({ left: target, behavior: 'smooth' });
    }
    // After a manual drag (which suspends CSS scroll-snap for a fluid feel),
    // settle on the nearest card rather than jumping a full page.
    function snapToNearest() {
      row.scrollTo({ left: Math.min(nearestIndex() * cardStep(), maxScroll()), behavior: 'smooth' });
    }

    row.addEventListener('scroll', function () { render(); }, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { render(); }).observe(row);
    } else {
      window.addEventListener('resize', render);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByPage(1); });

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragFrom = { x: e.clientX, sl: row.scrollLeft, pointerId: e.pointerId };
      dragMoved = false;
      dragging = true;
    });
    row.addEventListener('pointermove', function (e) {
      if (!dragging || !dragFrom) return;
      if (!dragMoved && Math.abs(e.clientX - dragFrom.x) > 6) {
        // Only now do we know this is a real drag, not a click - start
        // intercepting the pointer so text selection doesn't fight the drag.
        dragMoved = true;
        row.classList.add('mnc-indrow--dragging');
        row.setPointerCapture(dragFrom.pointerId);
      }
      if (dragMoved) {
        row.scrollLeft = dragFrom.sl - (e.clientX - dragFrom.x);
      }
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var wasDragging = dragMoved;
      dragFrom = null;
      row.classList.remove('mnc-indrow--dragging');
      if (wasDragging) {
        snapToNearest();
      }
    }
    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);

    render();
  }

  document.querySelectorAll('[data-mnc-industries]').forEach(setupIndustries);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mnc-industries]');
    if (el) setupIndustries(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
